import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name.split(" ")[0]}`);
      if (u.role === "tutor") nav("/admin");
      else if (u.role === "parent") nav("/parent");
      else nav("/student");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen hero-radial">
      <Navbar/>
      <div className="max-w-md mx-auto px-6 py-20">
        <div className="text-xs uppercase tracking-[0.3em] gold-text mb-4">Sign in</div>
        <h1 className="font-serif text-4xl tracking-tighter-x brand-navy mb-2">Welcome back.</h1>
        <p className="text-slate-600 mb-10">Continue your path to genius.</p>

        <form onSubmit={submit} className="space-y-5 bg-white rounded-xl border border-slate-200 p-8">
          <Field label="Email" type="email" val={email} set={setEmail} testid="login-email"/>
          <Field label="Password" type="password" val={password} set={setPassword} testid="login-password"/>
          <button disabled={loading} type="submit" className="btn-gold w-full py-3 rounded-md" data-testid="login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <p className="text-center text-sm text-slate-500">No account? <Link to="/signup" className="brand-navy font-medium hover:gold-text">Start a free trial</Link></p>
          <p className="text-center text-xs text-slate-400 pt-4 border-t border-slate-100">
            Demo: student@test.com / Student123! · parent@test.com / Parent123!
          </p>
        </form>
      </div>
      <Footer/>
    </div>
  );
}

function Field({label,val,set,type="text",testid}){return(<div><label className="text-xs uppercase tracking-widest text-slate-500 mb-2 block">{label}</label><input required type={type} value={val} onChange={e=>set(e.target.value)} className="w-full border border-slate-300 rounded-md px-4 py-3 bg-white text-sm" data-testid={testid}/></div>);}
